export const getStyles = () => {
    const styles = {
        ul: { 
            listStyle: 'none', 
            m: 0, 
            p: 0 
        }
    }
    return styles;
}